(function () {
  'use strict';

  function initStickyCta(bar) {
    if (!bar) return;

    var revealAfterScroll = bar.getAttribute('data-reveal-after-scroll') === 'true';
    var revealAmount = parseFloat(bar.getAttribute('data-reveal-scroll-amount')) || 0;
    var isBottom = bar.classList.contains('sc--bottom');
    var isTop = bar.classList.contains('sc--top');

    function isCurrentlyVisible() {
      return window.getComputedStyle(bar).display !== 'none';
    }

    function applyBodySpacing() {
      if (!isCurrentlyVisible()) {
        if (isBottom) document.body.style.paddingBottom = '';
        if (isTop) document.body.style.paddingTop = '';
        return;
      }

      var height = bar.offsetHeight;

      if (isBottom) {
        document.body.style.paddingBottom = height + 'px';
      }
      if (isTop) {
        document.body.style.paddingTop = height + 'px';
      }
    }

    function updateRevealState() {
      if (!revealAfterScroll) return;
      var scrolled = window.scrollY || window.pageYOffset;
      if (scrolled >= revealAmount) {
        bar.classList.remove('sc-is-hidden');
      } else {
        bar.classList.add('sc-is-hidden');
      }
    }

    if (revealAfterScroll) {
      bar.classList.add('sc-is-hidden');
      updateRevealState();
      window.addEventListener('scroll', updateRevealState, { passive: true });
    }

    applyBodySpacing();
    window.addEventListener('resize', applyBodySpacing);
    window.addEventListener('load', applyBodySpacing);
  }

  function init() {
    var bars = document.querySelectorAll('[data-sc]');
    bars.forEach(initStickyCta);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();